/* eslint-disable @typescript-eslint/restrict-plus-operands */
import { Grid } from '@mui/material'
import Box from '@mui/material/Box'
import { GeneralDocumentUploader } from '../../Pages/Referral/GeneralDocuments'
import { type DocumentData, DocumentInfo, type DocumentUpdateModel } from './DocumentInfo'
import SimpleAccordion from '../Accordian'
import { type DocumentFile } from '../Program/ProgramVerificationDetails'
import { useAuth } from '../../hooks/use-auth'
import '../../core/styles.css'
import { type DocumentTarget } from '../../core/types'

export function GeneralDocumentAccordion (props: {
  childId: number
  childName: string
  docTypeId: number
  documentTarget: DocumentTarget
  disabled: boolean
  id: number
  years: number[]
  title: string
  summary: string
  tag: string
  files: DocumentFile[]
  onDocumentUploaded: (file: File) => Promise<void>
  onDocumentAttached: (docs: DocumentData[]) => Promise<void>
  setFiles: (files: DocumentFile[]) => Promise<void>

}): JSX.Element {
  const auth = useAuth()
  const displayClass = 'CardDisplay'
  const handleVerifyChange = async (docId: number, verifyMode: boolean): Promise<void> => {
    const newFileList = [...props.files]
    const updatedFile = newFileList.filter(f => f.doc.documentID === docId)[0]
    updatedFile.editMode = verifyMode
    await props.setFiles(newFileList)
  }
  const handleDocVerified = async (docId: number, data: DocumentUpdateModel): Promise<void> => {
    const newFileList = [...props.files]
    const updatedFile = newFileList.filter(f => f.doc.documentID === docId)[0]
    updatedFile.doc.caregivers.forEach(element => {
      element.selected = data.caregivers.some(d => d === element.caregiverID)
    })
    updatedFile.editMode = false
    updatedFile.doc.verified = true
    updatedFile.doc.incomeAmount = data.incomeAmount
    updatedFile.doc.incomeYear = data.incomeYear
    updatedFile.doc.verifiedBy = (auth.user?.firstName ?? '') + ' ' + (auth.user?.lastName ?? '')
    updatedFile.doc.verifiedDate = new Date()
    updatedFile.doc.verificationNote = data.verificationNote
    await props.setFiles(newFileList)
  }
  const handleDocUnverified = async (docId: number): Promise<void> => {
    const newFileList = [...props.files]
    const updatedFile = newFileList.filter(f => f.doc.documentID === docId)[0]
    updatedFile.doc.verified = false
    await props.setFiles(newFileList)
  }
  const handleDelete = async (docId: number): Promise<void> => {
    const newFileList = [...props.files].filter(f => f.doc.documentID !== docId)
    await props.setFiles(newFileList)
  }
  return <SimpleAccordion
    dataTestid={`documentType${props.title}Accordion`}
    title={props.title} key={props.title.toString() + 'accordion'}
    width={'100%'}
    icon={<></>}
    summary={props.summary}
    className={'CardDisplay'}
    sx={{ border: 'none' }}
    dividerBorderStyle='1px solid rgba(0, 0, 0, 0.1);'
    tag={props.tag}
    body={<>
      <Box sx={{ fontWeight: 400, fontSize: '0.75em' }} data-testid={displayClass}>
        <Grid container width={'100%'} sx={{ justifyItems: 'center', gap: 2 }}>
          {props.files.map(d => {
            const data: DocumentData = d.doc
            return <Grid item sx={{ justifyItems: 'center', width: '-webkit-fill-available' }}>
              <DocumentInfo
                yearOptions={props.years}
                verifyMode={d.editMode}
                setVerifyMode={handleVerifyChange}
                onVerify={handleDocVerified}
                onUnVerify={handleDocUnverified}
                onDelete={handleDelete}
                document={data} disabled={props.disabled} documentID={data.documentID} childID={props.childId}
              />
            </Grid>
          })}
        </Grid>
      </Box>
      {!props.disabled && (
        <Box>
          <GeneralDocumentUploader childID={props.childId} documentTypeId={props.docTypeId}
            readOnly={false} years={props.years} childName={props.childName}
            onDocumentAttach={props.onDocumentAttached }
            onDocumentUploaded={props.onDocumentUploaded }
            documentTarget={props.documentTarget}
            referenceType={'programVerification'} referenceId={props.id} incomeRelated={false}
          />
        </Box>
      )}
    </>}
  />
}
